import { array, object, string } from 'yup';
import { EntityLabels } from '@web-shared/types';
import { EBOL_STATUS } from '../../../../../../api/types/EbolStatus';
import { EBOL_ACTION_REASON, EBOL_ACTION_REASON_SOURCE, EbolActionFormValues } from './types';

export const FIELD_NAMES = {
  REASONS: 'reasons',
  DETAILS: 'details',
  PHOTOS: 'photos',
} as const;

export const initialValues: EbolActionFormValues = {
  [FIELD_NAMES.REASONS]: [],
  [FIELD_NAMES.DETAILS]: '',
  [FIELD_NAMES.PHOTOS]: [],
};

export const maxDetailsLength = 300;
export const detailsRows = 6;
  
export const validationSchema = object({
  [FIELD_NAMES.REASONS]: array().of(object()).required().min(1, { key: 'label_selectAtLeastReason', values: { count: 1 } }),
  [FIELD_NAMES.DETAILS]: string().nullable().max(maxDetailsLength),
  [FIELD_NAMES.PHOTOS]: array().of(object()),
});

export const actionReasonLabels: EntityLabels<EBOL_ACTION_REASON> = {
  [EBOL_ACTION_REASON.MISSING_ITEMS]: 'label_missingItems',
  [EBOL_ACTION_REASON.DAMAGED_GOODS]: 'label_damagedGoods',
  [EBOL_ACTION_REASON.INCORRECT_SHIPMENT]: 'label_incorrectShipment',
  [EBOL_ACTION_REASON.BLUETOOTH_TAG_BROKEN]: 'label_bluetoothTagBroken',
  [EBOL_ACTION_REASON.DOCUMENTATION_MISMATCH]: 'label_documentationMismatch',
  [EBOL_ACTION_REASON.OTHER]: 'label_other',
};

export const ebolActionSuccessMessages: EntityLabels<EBOL_ACTION_REASON_SOURCE> = {
  [EBOL_STATUS.REJECTED]: 'message_shipmentRejected',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'message_shipmentAcceptedWithDiscrepancies',
};

export const ebolActionModalTitles: EntityLabels<EBOL_ACTION_REASON_SOURCE> = {
  [EBOL_STATUS.REJECTED]: 'label_rejectShipment',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'label_acceptShipmentWithDiscrepancies',
};

export const ebolActionModalDescriptions: EntityLabels<EBOL_ACTION_REASON_SOURCE> = {
  [EBOL_STATUS.REJECTED]: 'description_rejectShipment',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'description_acceptShipmentWithDiscrepancies',
};

export const ebolActionReasonPlaceholders: EntityLabels<EBOL_ACTION_REASON_SOURCE> = {
  [EBOL_STATUS.REJECTED]: 'label_reasonForRejection',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'label_reasonForReportedDiscrepancy',
};

export const ebolActionDetailsPlaceholders: EntityLabels<EBOL_ACTION_REASON_SOURCE> = {
  [EBOL_STATUS.REJECTED]: 'label_additionalDetails',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'description_describeIssuesWith',
};

export const ebolActionAddPhotoDescriptions: EntityLabels<EBOL_ACTION_REASON_SOURCE> = {
  [EBOL_STATUS.REJECTED]: 'description_addTruckCargoPhotosForRejection',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'description_addTruckCargoPhotosWithDiscrepancies',
};